export default __webpack_public_path__ + "imgs/beTogether02.86a6872.jpeg";